import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

// Country-code phone input for public storefront forms (Contact, product
// enquiries). Auto-detects the visitor's country from their IP on first
// load so the right dial code is preselected — falls back to India (the
// company's home market) if detection fails or is blocked (ad blockers,
// offline, etc).
export default function StorePhoneInput({ value, onChange, placeholder = 'Phone number', required }) {
  const [defaultCountry, setDefaultCountry] = useState('IN');

  useEffect(() => {
    let cancelled = false;
    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(d => { if (!cancelled && d?.country_code) setDefaultCountry(d.country_code); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="sf-phone-input">
      <style>{`
        .sf-phone-input .PhoneInput { display: flex; align-items: center; gap: 8px; border: 1.5px solid #e5e5e5; border-radius: 8px; padding: 0 11px; height: 38px; background: #fff; }
        .sf-phone-input .PhoneInputInput { border: none; outline: none; font-size: 14px; font-family: inherit; flex: 1; min-width: 0; }
        .sf-phone-input .PhoneInputCountry { margin-right: 2px; }
      `}</style>
      <PhoneInput
        international
        defaultCountry={defaultCountry}
        value={value}
        onChange={v => onChange(v || '')}
        placeholder={placeholder}
        required={required}
      />
    </div>
  );
}
